import { CouponDTO } from '@/components/fakeDoor/types';
import { DEFAULT_MULTIPLE_COUPON_VALUE } from '@/constants/index';
import { APPOINTMENT_CARD_TYPE } from '@/constants/enums';
import { Coupon, ExtractRewardResponseDto } from '@/types';

export function getRewardDetailsFromCoupons(coupons: Coupon[]) {
    if (!Array.isArray(coupons) || coupons.length === 0) {
        return {
            isCouponAvailable: false,
            couponCode: null,
            offerDetails: null,
        };
    }

    if (coupons.length === 1) {
        const coupon = coupons[0];
        return {
            isCouponAvailable: true,
            couponCode: coupon?.coupon_code ?? null,
            offerDetails: {
                offer_title: coupon?.title ?? null,
                offer_description: coupon?.description ?? null,
            },
        };
    }

    return {
        isCouponAvailable: true,
        couponCode: DEFAULT_MULTIPLE_COUPON_VALUE,
        offerDetails: DEFAULT_MULTIPLE_COUPON_VALUE,
    };
}

export function getRewardDetailsFromNotes(coupon_details: CouponDTO) {
    if (!coupon_details || !coupon_details.coupon_id) {
        return {
            isCouponAvailable: false,
            couponCode: null,
            offerDetails: null,
        };
    }

    return {
        isCouponAvailable: true,
        couponCode: coupon_details.coupon_code ?? null,
        offerDetails: {
            offer_title: coupon_details.title ?? null,
            offer_description: coupon_details.description ?? null,
        },
    };
}

export function getMatchingCouponsByServiceType(
    coupons: Coupon[] | undefined,
    rewardServiceType: string
): Coupon[] {
    if (!Array.isArray(coupons)) {
        return [];
    }
    return coupons.filter(
        (coupon: Coupon) =>
            (coupon?.meta?.service_type ?? '') === rewardServiceType
    );
}

export function hasServiceCoupons(
    serviceImage: any,
    rewardDetails: ExtractRewardResponseDto | null | undefined
): boolean {
    if (!serviceImage?.key) {
        return false;
    }

    const matchingCoupons = getMatchingCouponsByServiceType(
        rewardDetails?.coupons,
        serviceImage?.key
    );

    const hasCoupons = matchingCoupons && matchingCoupons.length > 0;

    return !!hasCoupons;
}

export function sortServicesByCouponAvailability(
    servicesImages: any[],
    rewardDetails: ExtractRewardResponseDto | null | undefined
): any[] {
    if (!Array.isArray(servicesImages) || servicesImages.length === 0) {
        return servicesImages;
    }

    const servicesWithCoupons: any[] = [];
    const servicesWithoutCoupons: any[] = [];

    servicesImages.forEach((serviceImage) => {
        if (hasServiceCoupons(serviceImage, rewardDetails)) {
            serviceImage.isCouponAvailable = true;
            servicesWithCoupons.push(serviceImage);
        } else {
            serviceImage.isCouponAvailable = false;
            servicesWithoutCoupons.push(serviceImage);
        }
    });

    return [...servicesWithCoupons, ...servicesWithoutCoupons];
}

export function getRewardValue(
    serviceImage: any,
    rewardDetails: ExtractRewardResponseDto
) {
    if (!rewardDetails || !rewardDetails.coupons) {
        return null;
    }
    const coupon = rewardDetails.coupons.find(
        (coupon: Coupon) => coupon.meta?.service_type === serviceImage.key
    );
    return coupon?.meta?.reward_value ?? null;
}
